import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import Amplify from "aws-amplify";
import { awsConfig } from "./settings/setting";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import Main from "./main";
import { Provider } from "react-redux";
import Store from "./store/store";
import "react-circular-progressbar/dist/styles.css";
import "react-datepicker/dist/react-datepicker.css";
import "./styles/main.scss";
import { MantineProvider } from "@mantine/core";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "./i18n";
library.add(fas as any, faSignOutAlt as any);
if (process.env.REACT_APP_AUTH_MODE === "cognito") {
  Amplify.configure(awsConfig);
}

ReactDOM.render(
  <MantineProvider
    withGlobalStyles
    withNormalizeCSS
    theme={{
      colors: {
        brand: [
          "#fff4f0",
          "#ffe4dc",
          "#ffc5b5",
          "#ff9a7e",
          "#ff7252",
          "#f04d2a",
          "#db3f20",
          "#bc3219",
          "#972614",
          "#731b10",
        ],
        playsafelyBlue: [
          "#fff4f0",
          "#ffe4dc",
          "#ffc5b5",
          "#ff9a7e",
          "#ff7252",
          "#f04d2a",
          "#db3f20",
          "#bc3219",
          "#972614",
          "#731b10",
        ],
        playsafelyGreen: [
          "#fff7f4",
          "#ffe9e2",
          "#ffd0c3",
          "#ffad98",
          "#ff8a6e",
          "#ff7658",
          "#e75c3f",
          "#c7442d",
          "#9e321f",
          "#752316",
        ],
      },
      primaryColor: "brand",
      fontFamily: "'Poppins', sans-serif",
      headings: {
        fontFamily: "'Anton', sans-serif",
        fontWeight: 400,
      },
    }}
  >
    <Provider store={Store}>
      <Main />
    </Provider>
  </MantineProvider>,
  document.getElementById("root")
);
serviceWorkerRegistration.register();
reportWebVitals();
